// OWNER: AREA-OPS
// Section layout: supplies the "Applications" breadcrumb for every page under /applications.
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/applications')({
  staticData: { crumb: 'Applications' },
  component: Outlet,
})
